import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface WarningModalData {
	title: string;
	message: string;
	cancelButtonText: any;
	confirmButtonText: string;
	confirmBtnCssClass: string;
}

@Component({
	selector: "app-warning-modal",
	templateUrl: "./warning-modal.component.html",
	styleUrls: ["./warning-modal.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WarningModalComponent implements OnInit {
	private matDialogRef = inject<MatDialogRef<WarningModalComponent>>(MatDialogRef);
	data = inject<WarningModalData>(MAT_DIALOG_DATA);

	title: string;
	message: string;
	cancelButtonText: any;
	confirmButtonText: string;

	/** Inserted by Angular inject() migration for backwards compatibility */
	constructor(...args: unknown[]);
	constructor() {}

	ngOnInit(): void {
		this.title = this?.data?.title || "Are you sure?";
		this.message = this?.data?.message || "";

		this.confirmButtonText = this?.data?.confirmButtonText || "Ok";
		if (this?.data?.cancelButtonText !== false) {
			this.cancelButtonText = this?.data?.cancelButtonText || "Cancel";
		}
	}

	close(res?) {
		this.matDialogRef.close(res);
	}
}
